import React from 'react';
import Header from "./Header";
import Footer from "./Footer"
import { useNavigate } from 'react-router-dom';
import { Brain } from 'lucide-react';
import SEOHeader from '../../components/SEOHeader';

const LandingPage = () => {
  const marineBlue = '#1e5f74' // Dark marine blue color
  const marineBlueDark = '#164a5a' // Even darker for hover states
  const lightBlue = '#5fb3d4' // Lighter blue for logo to match reference

  const navigate = useNavigate();

  return (
    <>
      <SEOHeader/>
      <Header />
      <section className="relative py-20 md:py-32" style={{ background: 'linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%)' }}>
        {/* White transparent "Trusted Clinic" background text - keep left positioned */}
        <div className="absolute top-60  left-8  text-5xl text-white opacity-70 pointer-events-none z-0 leading-tight">
          <div>TRUSTED</div>
          <div>CLINIC</div>
        </div>
        
        {/* Brain drawing image - large and positioned on right half */}
        <div className="absolute top-0 right-0 w-1/2 h-full opacity-20 pointer-events-none z-5 text-white overflow-hidden">          <img 
            src="/images/brain.png" 
            alt="Brain drawing" 
            className="w-full h-full object-cover object-center blur-md"
    style={{ transform: 'translateX(10%) translateY(-10%)' }} />
        </div>

        {/* Centered container */}
        <div className="flex justify-center relative" style={{ zIndex: 1 }}>
          <div className="w-full max-w-6xl text-center px-4">
            

            {/* Main Heading - centered */}
            {/* <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Specialist <span style={{ color: marineBlue }}>ADHD</span> Care Clinic
            </h1> */}
             <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Already Diagnosed with <span style={{ color: marineBlue }}>ADHD</span> ? 
            </h1>

            {/* Updated Subtitle - matching reference "Fast private diagnosis + FREE ongoing care for life" styling exactly */}
            <p className="text-lg text-gray-500 mb-8 font-normal">
             Australia’s First Specialist ADHD Care Clinic Focused 
on Ongoing Support
            </p>
{/* Badge - centered */}
            <div className="flex justify-center mb-6">
              <span className="inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm font-medium border-gray-200" style={{ backgroundColor: `${marineBlue}20`, color: marineBlue }}>
                100% Telehealth with groundbreaking support
              </span>
            </div>
            {/* Select text - centered */}
            <p className="text-lg text-gray-700 mb-8">
              Select
            </p>

            {/* Two Square Cards - centered */}
<div className="flex justify-center mb-8">
  {/* Container grid */}
  <div className="grid md:grid-cols-2 gap-6 max-w-5xl w-full">

    {/* Assessment & Diagnosis (LEFT) */}
    <div className="relative bg-white rounded-xl border border-gray-200 shadow-sm p-6 flex flex-col ">
      {/* green label top-right */}
      <span className="absolute top-4 right-5 text-green-600 text-sm font-medium">
        Coming Soon
      </span>

      {/* heading */}
      <h3 className="font-semibold text-xl text-gray-900 text-left mt-4">
        Assessment &amp; Diagnosis
      </h3>

      <p className="text-xs text-gray-600 mt-2 text-left">
        Comprehensive ADHD evaluation with licensed professionals
      </p>

      {/* alignment spacer to match right card's price pill + gaps (~40px) */}
      <div className="h-10" aria-hidden="true" />

      {/* points with arrow (remove extra top margin) */}
      <ul className="space-y-1.5 text-xs mt-3 text-gray-900 leading-snug">
        {[
          'Initial consultation with ADHD specialist',
          'Comprehensive symptom assessment',
          'Personalized diagnosis report',
          'Treatment recommendations',
        ].map((point, idx) => (
          <li key={idx} className="flex items-start gap-2">
            <svg
              className="w-3.5 h-3.5 text-green-600 mt-[2px] flex-shrink-0"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            <span>{point}</span>
          </li>
        ))}
      </ul>
    </div>

    {/* Care Plan (RIGHT) */}
    <div
      className="relative bg-white rounded-xl border-2 shadow-sm p-6 flex flex-col cursor-pointer"
      style={{ borderColor: 'rgb(30, 95, 116)' }}
      onClick={() => navigate('/care-plan')}
    >
      {/* green label */}
      <span className="absolute top-4 right-5 text-green-600 text-sm font-medium">
        Available NOW
      </span>

      {/* heading */}
      <h3 className="font-semibold text-xl text-gray-900 mb-1 text-left mt-4 ">
        Care Plan
      </h3>

      {/* subtext */}
      <p className="text-xs text-gray-600 mb-4 text-left mt-1">
        Weekly monitoring with nurse support and detailed reporting
      </p>

      {/* price pill */}
      <div className="mb-3 text-left flex">
        <span className="inline-block bg-blue-50 px-2.5 py-0.5 rounded-md text-xs">
          <span className="font-semibold text-green-800">$20</span>
          <span className="text-gray-600">/week </span>
          <span className="text-gray-600"> (or </span>
          <span className="font-semibold text-green-800">$79</span>
          <span className="text-gray-600">/month)</span>
        </span>
      </div>

      {/* feature points as divs */}
      <div className="space-y-1.5 text-xs text-gray-900 leading-snug mt-2">
        <div className="flex items-start gap-2">
          <svg className="w-3.5 h-3.5 text-green-600 mt-[2px] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          <span>Weekly progress monitoring</span>
        </div>
        <div className="flex items-start gap-2">
          <svg className="w-3.5 h-3.5 text-green-600 mt-[2px] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          <span>Dedicated nurse support</span>
        </div>
        <div className="flex items-start gap-2">
          <svg className="w-3.5 h-3.5 text-green-600 mt-[2px] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          <span>Comprehensive weekly reports</span>
        </div>
        <div className="flex items-start gap-2">
          <svg className="w-3.5 h-3.5 text-green-600 mt-[2px] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          <span>Goal tracking and adjustments</span>
        </div>
      </div>

      {/* spacer */}
      <div className="flex-grow" />

      {/* button */}
      <button
        className="inline-flex items-center justify-center text-white px-5 py-2 rounded-lg font-semibold w-full text-[12px] mt-6"
        style={{ backgroundColor: 'rgb(30, 95, 116)' }}
        onClick={(e) => {
          e.stopPropagation();
          navigate('/care-plan');
        }}
      >
        Explore the Care Plan
        <svg className="ml-2 w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
        </svg>
      </button>
    </div>
  </div>
</div>



          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default LandingPage;
